export const DELEGATION_FORM_STATUS = {
    DRAFT: "draft",
    COMPLETED: "completed",
    FINAL: "final",
    DELETED: "deleted",
} as const;

export type DelegationFormStatus =
    typeof DELEGATION_FORM_STATUS[keyof typeof DELEGATION_FORM_STATUS];

export const normalizeDelegationStatus = (status?: string | null): DelegationFormStatus => {
    const normalized = String(status || "").trim().toLowerCase();
    if (normalized === DELEGATION_FORM_STATUS.COMPLETED) return DELEGATION_FORM_STATUS.COMPLETED;
    if (normalized === DELEGATION_FORM_STATUS.FINAL) return DELEGATION_FORM_STATUS.FINAL;
    if (normalized === DELEGATION_FORM_STATUS.DELETED) return DELEGATION_FORM_STATUS.DELETED;
    return DELEGATION_FORM_STATUS.DRAFT;
};

export const isDelegationCompletedStatus = (status?: string | null) => {
    const normalized = normalizeDelegationStatus(status);
    return normalized === DELEGATION_FORM_STATUS.COMPLETED || normalized === DELEGATION_FORM_STATUS.FINAL;
};

export const getDelegationStatusLabel = (status?: string | null) => {
    const normalized = normalizeDelegationStatus(status);
    if (normalized === DELEGATION_FORM_STATUS.COMPLETED || normalized === DELEGATION_FORM_STATUS.FINAL) {
        return "Complete";
    }
    if (normalized === DELEGATION_FORM_STATUS.DELETED) {
        return "Deleted";
    }
    return "Draft";
};

export const getDelegationStatusTagValue = (status?: string | null) =>
    getDelegationStatusLabel(status).toUpperCase();

export const getDelegationStatusSeverity = (status?: string | null): "success" | "warning" | "danger" => {
    const normalized = normalizeDelegationStatus(status);
    if (normalized === DELEGATION_FORM_STATUS.COMPLETED || normalized === DELEGATION_FORM_STATUS.FINAL) {
        return "success";
    }
    if (normalized === DELEGATION_FORM_STATUS.DELETED) {
        return "danger";
    }
    return "warning";
};
